import React from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Jobs.css';

const Jobs = props => {
    const { isDesktop, items } = props;

    useEffect(() => {
        const src = 'https://jobs.ashbyhq.com/hudson-pacific-properties/embed?version=2';

        // 1) Add the script only if it doesn't already exist
        let script = document.querySelector(`script[src="${src}"]`);
        let createdByThisComponent = false;

        if (!script) {
            script = document.createElement('script');
            script.src = src;
            script.async = true;
            document.body.appendChild(script);
            createdByThisComponent = true;
        }

        // 2) Observers (only if MutationObserver exists)
       /* const observers = [];

        const idName = 'ashby_embed_iframe';
        const toCssHeight = h => (h && /^\d+$/.test(h) ? `${h}px` : h); // "420" -> "420px"

        let tracked = false;

        const applyHeight = el => {
            const attr = el.getAttribute('height');
            if (!attr) return;

            const elParent = document.getElementById('ashby_embed');
            if (elParent) {
                elParent.style.height = toCssHeight(attr);
            }
        };

        const watchIframe = el => {
            if (!el || tracked) return;

            tracked = true; 

            // Watch future changes to the height attribute
            const mo = new MutationObserver(mutations => {
                for (const m of mutations) {
                    if (m.attributeName === 'height') {
                        requestAnimationFrame(() => applyHeight(el));
                        break;
                    }
                }
            });

            mo.observe(el, { attributes: true, attributeFilter: ['height'] });
            observers.push(mo);

            // Apply the initial height in case it's already set
            applyHeight(el);
        };

        const tryAttach = () => {
            const el = document.getElementById(idName);
            if (el && el.tagName === 'IFRAME') watchIframe(el);
        };

        // If MutationObserver exists, try to attach immediately; otherwise watch the DOM until it appears
        if (typeof MutationObserver !== 'undefined') {
            tryAttach();

            if (!tracked) {
                const rootObserver = new MutationObserver(() => {
                    if (!tracked) tryAttach();
                });

                rootObserver.observe(document.body, { childList: true, subtree: true });
                observers.push(rootObserver);
            }
        }*/

        // 3) Cleanup: runs when the component unmounts (and may run extra times in dev with StrictMode)
        return () => {
            //observers.forEach(o => o.disconnect());

            // Remove the script ONLY if this component created it
            if (createdByThisComponent && script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);

    return (
        <section className="section jobs-section">
            <div id="ashby_embed"></div>
        </section>
    );
};

Jobs.propTypes = {
    isDesktop: PropTypes.bool,
    items: PropTypes.object,
};

export default Jobs;
